module.exports = __webpack_public_path__ + "img/8.176940cf.png";